import _ from "lodash";

export function regexFromUser(input) {
  try {
    return new RegExp(input, "i");
  } catch {
    return new RegExp(_.escapeRegExp(input), "i");
  }
}
